import { useEffect, useState } from 'react';

export default function useScrollStatus() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [scrollDimension, setScrollDimension] = useState({ x: 0, y: 0 });
  const scrollListener = () => {
    setIsScrolled(window.scrollY > 0);
    setScrollDimension({ x: window.scrollX, y: window.scrollY });
  };
  useEffect(() => {
    window.addEventListener('scroll', scrollListener);
    return () => {
      window.removeEventListener('scroll', scrollListener);
    };
  });

  return { isScrolled, scrollDimension };
}
